
import { empty as observableEmpty, of as observableOf } from 'rxjs'

import { connect } from 'react-redux'
import { mergeMap } from 'rxjs/operators'

import {
  ARTICLE_TYPE,
  Feed,
  GIF_TYPE,
  NEW_RANGE_FILTER,
  PHOTO_TYPE,
  RangeFilter,
  VIDEO_TYPE
} from 'interfaces'
import { TEXT_TYPE } from 'interfaces/Content/ContentType'
import { getArticles } from 'services/content/articles/actions'
import { getGifs } from 'services/content/gifs/actions'
import { getPhotos } from 'services/content/photos/actions'
import { getTexts } from 'services/content/texts/actions'
import { getVideos } from 'services/content/videos/actions'
import { StoreState, StoreThunkDispatch } from 'store/state'




import { STOCK_CONTENT_PROVIDERS_ALL, StockContentProvider } from 'interfaces/Content/StockContentProvider'
import { STOCK_ALL_FILTER, STOCK_GIF_TYPE, STOCK_PHOTO_TYPE, STOCK_VIDEO_TYPE } from 'interfaces/Content/StockContentTypes'
import { fetchStockContent } from 'services/content/stock/actions'
import { SortBy } from 'services/content/util'
import { FetchFeedContent } from './FetchFeedContent'
import { ContentType, FilterType } from 'shared'

export interface FetchFeedPageContentOwnProps {
  feed: Feed
  page: number
  range: RangeFilter
  sortBy?: SortBy
  stockSource?: StockContentProvider

  skip?: ContentType[]
  only?: FilterType
}

function mapStateToProps(_state: StoreState, ownProps: FetchFeedPageContentOwnProps) {
  const { page, range, feed, only, sortBy } = ownProps
  return {
    ...ownProps,
    hash: `feed:${feed.id}:${only || 'any'}:${page}:${range}:${sortBy || 'any'}` as string | undefined
  }
}

function mapDispatchToProps(dispatch: StoreThunkDispatch, ownProps: FetchFeedPageContentOwnProps) {
  const { page, range, feed, skip, only, sortBy, stockSource } = ownProps

  const skipVideos = (only && only !== VIDEO_TYPE) || (skip && skip.includes(VIDEO_TYPE))
  const skipGifs = (only && only !== GIF_TYPE) || (skip && skip.includes(GIF_TYPE))
  const skipPhotos = (only && only !== PHOTO_TYPE) || (skip && skip.includes(PHOTO_TYPE))
  const skipTexts = (only && only !== TEXT_TYPE) || (skip && skip.includes(TEXT_TYPE))
  const skipArticles = (only && only !== ARTICLE_TYPE) || (skip && skip.includes(ARTICLE_TYPE))
  const skipStockVideos = (only && only !== STOCK_VIDEO_TYPE)
  const skipStockGifs = (only && only !== STOCK_GIF_TYPE)
  const skipStockPhotos = (only && only !== STOCK_PHOTO_TYPE)
  const stockFilter = stockSource || STOCK_CONTENT_PROVIDERS_ALL

  return {
    getVideos: () => skipVideos
      ? observableEmpty()
      : dispatch(getVideos(feed.uniqueSource + '', false, page, range, sortBy)).pipe(mergeMap((v: any) => observableOf(...v.items))),
    getStockVideos: () => skipStockVideos
      ? observableEmpty()
      : dispatch(getVideos(feed.uniqueSource + '', false, page, NEW_RANGE_FILTER, sortBy, true, stockFilter)).pipe(
        mergeMap((v: any) => observableOf(...v.items))),
    getGifs: () => skipGifs
      ? observableEmpty()
      : dispatch(getGifs(feed.uniqueSource + '', false, page, range, sortBy)).pipe(mergeMap((v: any) => observableOf(...v.items))),
    getStockGifs: () => skipStockGifs
      ? observableEmpty()
      : dispatch(getGifs(feed.uniqueSource + '', false, page, NEW_RANGE_FILTER, sortBy, true, stockFilter)).pipe(
        mergeMap((v: any) => observableOf(...v.items))),
    getPhotos: () => skipPhotos
      ? observableEmpty()
      : dispatch(getPhotos(feed.uniqueSource + '', false, page, range, sortBy)).pipe(mergeMap((p: any) => observableOf(...p.items))),
    getTexts: () => skipTexts
      ? observableEmpty()
      : dispatch(getTexts(feed.uniqueSource + '', false, page, range, sortBy)).pipe(mergeMap((p: any) => observableOf(...p.items))),
    getStockPhotos: () => skipStockPhotos
      ? observableEmpty()
      : dispatch(getPhotos(feed.uniqueSource + '', false, page, NEW_RANGE_FILTER, sortBy, true, stockFilter)).pipe(
        mergeMap((p: any) => observableOf(...p.items))),
    getArticles: () => skipArticles
      ? observableEmpty()
      : dispatch(getArticles(feed.uniqueSource + '', false, page, range, sortBy)).pipe(mergeMap((a: any) => observableOf(...a.items))),
    getStockAll: () => only === STOCK_ALL_FILTER
      ? dispatch(fetchStockContent(feed.uniqueSource + '', page, NEW_RANGE_FILTER, stockSource))
        .pipe(mergeMap((a: any) => observableOf(...a.items)))
      : observableEmpty()
  }
}

const WrappedFetchFeedContent = connect(mapStateToProps, mapDispatchToProps)(FetchFeedContent)

export default WrappedFetchFeedContent
